import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ERoutes } from '../../core/enums/routes.enum';

import { AboutUsComponent } from './about-us/about-us.component';
import { TripTestimonialsComponent } from './trip-testimonials/trip-testimonials.component';
import { TermsNConditionsComponent } from './terms-n-conditions/terms-n-conditions.component';
import { AccessibilityDeclarationComponent } from './accessibility-declaration/accessibility-declaration.component';

const routes: Routes = [
  {
    path: ERoutes.ABOUT_US,
    component: AboutUsComponent,
  },
  {
    path: ERoutes.TRIP_TESTIMONIALS,
    component: TripTestimonialsComponent,
  },
  {
    path: ERoutes.ACCESSIBILITY_DECLARATION,
    component: AccessibilityDeclarationComponent,
  },
  {
    path: ERoutes.TERMS_N_CONDITIONS,
    component: TermsNConditionsComponent,
  },
  {
    path: `${ERoutes.TERMS_N_CONDITIONS}/:lang`,
    component: TermsNConditionsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CompanyInfoRoutingModule {}
